import React from 'react'

const QuickPickerRow = (props) => {
    const { viewData } = props;

    // console.log("QuickPickerRow", viewData);

    return (
        <>
            <span className="uiMenuItemLabel">{viewData.label}</span>
        </>
    )
}

export default QuickPickerRow;
